import useDefinedContext from "hooks/useDefinedContext";
import XAxisActionsContext from "../contexts/XAxisActionsContext";

interface UseXAxisActionsProps {}

function useXAxisActions(props?: UseXAxisActionsProps) {
  return useDefinedContext(XAxisActionsContext);
}

export default useXAxisActions;
